import Vue from 'vue';
var RequestCounter = /** @class */ (function () {
    function RequestCounter() {
        /**
         * 当前请求数
         */
        this.count = 0;
        this.urls = [];
    }
    Object.defineProperty(RequestCounter.prototype, "inRequest", {
        /**
         * 是否正在请求
         */
        get: function () {
            return this.count > 0;
        },
        enumerable: false,
        configurable: true
    });
    RequestCounter.prototype.increment = function (url) {
        this.count += 1;
        this.urls.push(url);
    };
    RequestCounter.prototype.decrement = function (url) {
        this.count -= 1;
        this.urls.splice(this.urls.indexOf(url), 1);
    };
    RequestCounter.prototype.reset = function () {
        this.count = 0;
        this.urls = [];
    };
    RequestCounter.getInstance = function () {
        if (!RequestCounter.instance) {
            RequestCounter.instance = Vue.observable(new RequestCounter());
            // RequestCounter.instance = new RequestCounter();
        }
        return RequestCounter.instance;
    };
    return RequestCounter;
}());
export { RequestCounter };
